<template>
    <div class="gift-home">
        <div class="ranking">
            <div class="ranking-title">
                Famous Teacher Ranking <span class="line"></span>
            </div>
            <div class="ranking-list">
                <div class="ranking-item" @click="handleRoute()">
                    <img class="ranking-image" src="../assets/img/gift/rank-teacher-pic001.png">
                    <img class="ranking-icon" src="../assets/img/gift/1st.png">
                    <p>Ms. Dengdeng</p>
                </div>
                <div class="ranking-item">
                    <img class="ranking-image" src="../assets/img/gift/rank-teacher-pic002.png">
                    <img class="ranking-icon" src="../assets/img/gift/2nd.png">
                    <p>Ms. Crystal</p>
                </div>
                <div class="ranking-item">
                    <img class="ranking-image" src="../assets/img/gift/rank-teacher-pic003.png">
                    <img class="ranking-icon" src="../assets/img/gift/3rd.png">
                    <p>Ms. Joyce</p>
                </div>
                <div class="ranking-item">
                    <img class="ranking-image" src="../assets/img/gift/rank-teacher-pic003.png">
                    <p>Ms. -</p>
                </div>
                <div class="ranking-item">
                    <img class="ranking-image" src="../assets/img/gift/rank-teacher-pic003.png">
                    <p>Ms. -</p>
                </div>
            </div>
        </div>
        <div class="teachers">
            <img class="divider-image" src="../assets/img/gift/ata-line.png">
            <img class="divider-image-mobile" src="../assets/img/mobile/ata-line.png">
            <div class="teachers-title">
                All Teachers
            </div>
            <div class="teachers-list">
                <div class="teachers-item" v-for="item in list" :key="item.id" @click="handleRoute(item.id)">
                    <img class="teachers-image" :src="item.image">
                    <img v-if="item.icon" class="teachers-icon" :src="item.icon">
                    <div class="teachers-name">{{item.name}}</div>
                    <div class="teachers-subject">{{item.subject}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Gift Home",
        data() {
            return {
                list:[
                    {
                        id: 1,
                        image: require('../assets/img/gift/teacher-pic001.png'),
                        icon: require('../assets/img/gift/1st.png'),
                        name: 'Ms. Dengdeng',
                        subject: 'Chinese Teacher'
                    },
                    {
                        id: 2,
                        image: require('../assets/img/gift/teacher-pic002.png'),
                        name: 'Ms. Joyce',
                        subject: 'Spanish Teacher'
                    },
                    {
                        id: 3,
                        image: require('../assets/img/gift/teacher-pic003.png'),
                        name: 'Ms. Crystal',
                        subject: 'English Teacher'
                    },
                    {
                        id: 4,
                        image: require('../assets/img/gift/teacher-pic001.png'),
                        icon: require('../assets/img/gift/1st.png'),
                        name: 'Ms. Dengdeng',
                        subject: 'Chinese Teacher'
                    },
                    {
                        id: 5,
                        image: require('../assets/img/gift/teacher-pic002.png'),
                        name: 'Ms. Joyce',
                        subject: 'Spanish Teacher'
                    },
                    {
                        id: 6,
                        image: require('../assets/img/gift/teacher-pic003.png'),
                        name: 'Ms. Crystal',
                        subject: 'English Teacher'
                    }
                ]
            }
        },
        methods: {
            handleRoute(id) {
                this.$router.push({path: 'detail', query: {id: id}})
            }
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/GiftHome.scss";
    @import "../styles/mobile/GiftHome.scss";
</style>
